<div class="my-2" *ngxPermissionsOnly="[userPrivileges.MARKETER_SUPER_PRIVILEGE,userPrivileges.TENANT_PRIVILEGE,userPrivileges.TENANT_BASIC_PRIVILEGE,userPrivileges.MARKETER_BASIC_PRIVILEGE]">
    <div class="card">
        <div class="card-body table-responsive">
            <table class="table table-striped table-bordered table-sm row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Plots Sold</th>
                        <th>Total Commission (<i class="fas fa-rupee-sign mr-1"></i>)</th>
                        <th>Commission Earned (<i class="fas fa-rupee-sign mr-1"></i>)</th>
                        <th>Commission Paid (<i class="fas fa-rupee-sign mr-1"></i>)</th>
                        <th>Commission Pending (<i class="fas fa-rupee-sign mr-1"></i>)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let commission of Commissions.commissions">
                        <td>{{commission.name}}</td>
                        <td (click)="checkComissionDetails(commission)" style="cursor: pointer;">{{commission.numberOfPlotsSold}}</td>
                        <td>{{commission.totalCommission.toLocaleString('en-IN')}}</td>
                        <td>{{commission.commissionEarned.toLocaleString('en-IN')}}</td>
                        <td>{{commission.commissionPaid.toLocaleString('en-IN')}}</td>
                        <td>{{commission.commissionPending.toLocaleString('en-IN')}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>